import { useTranslation } from "react-i18next";
import { Grid, GridColumn } from "semantic-ui-react";

import { SnoozeItem } from "modules/AppointmentDetails/components/SnoozedItems/components";

import type { Appointment, Intervention, QuestionResult } from "models";

type SnoozedItemsProps = {
  appointment: Appointment;
  snoozedInterventions: Intervention[];
  snoozedQuestionItems: QuestionResult[];
};

export const SnoozedItemsTable = ({ appointment, snoozedInterventions, snoozedQuestionItems }: SnoozedItemsProps) => {
  const { t } = useTranslation();

  const snoozedItems = [...snoozedQuestionItems, ...snoozedInterventions];
  if (!snoozedItems.length) return null;

  const gridColumns = [
    { header: t("v8_title", "Title") },
    { header: t("v8_snooze_type", "Snooze type") },
    { header: t("v8_snooze_date", "Snooze date") },
    { header: t("v8_snooze_status", "Snooze status") },
    { header: t("v8_department", "Department") },
    { header: t("v8_note", "Note") },
    { header: "" }
  ];

  //TODO: Next step move this to table, not sure why it was added as grid in the first place, and with that, noBorder prop won't be needed anymore
  return (
    <div className="Appointment-SnoozedItems">
      <Grid columns={7}>
        {gridColumns.map(column => (
          <GridColumn key={column.header} className="header">
            <p>{column.header}</p>
          </GridColumn>
        ))}

        {snoozedQuestionItems.map((question, idx) => (
          <SnoozeItem
            key={`snoozed-question-item-${question.id}`}
            questionResult={question}
            appointment={appointment}
            snoozedItems={snoozedItems}
            noBorder={snoozedQuestionItems.length - 1 === idx && snoozedInterventions.length === 0}
          />
        ))}

        {snoozedInterventions.map((item, idx) => (
          <SnoozeItem
            key={`snoozed-intervention-item-${item.id}`}
            intervention={item}
            appointment={appointment}
            snoozedItems={snoozedItems}
            noBorder={snoozedInterventions.length - 1 === idx}
          />
        ))}
      </Grid>
    </div>
  );
};
